import { useState, forwardRef, useImperativeHandle } from 'react'

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";
import TextField from '@base/Inputs/Text'

export const AbrirNovaCaixaDialog = forwardRef((props, ref) => {
  
  const [caixa, setCaixa] = useState('');
  const [open, setOpen] = useState(props.aberto ?? false);

  useImperativeHandle(ref, () => ({
    closeDialog() {
      setCaixa('');
      setOpen(false);
    }
  }));

  const pistolarCaixa = (e) => {
    setCaixa(e.target.value);
    props.handlerCarregaCaixa(e.target.value);
  }

  return (
    <Dialog
      maxWidth={'sm'}
      fullWidth={true}
      closeDialog={props.aoFechar}
      openDialog={open}
      title='Informe o Código da Caixa'
    >
      <Grid container>
        <Grid item sm={12}>
          <TextField
            autoFocus
            inputProps={{
              maxLength: 10
            }}
            label={"Código da Caixa"}
            value={caixa}
            onChange={pistolarCaixa}
            onKeyPress={(e) => (e)}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
})

export default AbrirNovaCaixaDialog;
